export type TicketFieldOption = {
  id: number;
  name: string;
  value: string;
};

export type FieldValue = string | number | boolean | Array<string> | Array<File>;

export type ChildFieldCondition = {
  id: number;
  isRequired: boolean;
};

export type FieldCondition = {
  parentFieldId: number;
  parentFieldType: string | null;
  value: string;
  childFields: Array<ChildFieldCondition>;
};

export enum TicketFieldType {
  TAGGER = 'tagger',
  TEXT = 'text',
  CHECKBOX = 'checkbox',
  DATE = 'date',
  INTEGER = 'integer',
  DECIMAL = 'decimal',
  REGEXP = 'regexp',
  PARTIALCREDITCARD = 'partialcreditcard',
  MULTISELECT = 'multiselect',
  LOOKUP = 'lookup',
  TEXTAREA = 'textarea',
  // Mandatory fields, always present in the form
  SUBJECT = 'subject',
  DESCRIPTION = 'description',
  EMAIL = 'email',
  ATTACHMENT = 'attachment',
}

export type TicketField = {
  id: number;
  type: TicketFieldType;
  title: string;
  description: string;
  required: boolean;
  options?: Array<TicketFieldOption>;
};
